export const DOCUMENT_ACCEPT = '.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf'
export const DOCUMENT_MAX_BYTES = 20 * 1024 * 1024
const MIMES = {
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
}

export function documentType(file) {
  const ext = file?.name?.match(/\.([^.]+)$/)?.[1].toLowerCase()
  if (!Object.hasOwn(MIMES, ext || '')) throw new Error('文件只支持 Word（.doc、.docx）和 PDF（.pdf）')
  const mime = String(file.type || '').split(';')[0].trim().toLowerCase()
  if (mime && mime !== 'application/octet-stream' && mime !== MIMES[ext]) throw new Error('文件扩展名与类型不一致')
  if (!file.size) throw new Error('文件为空')
  if (file.size > DOCUMENT_MAX_BYTES) throw new Error('Word / PDF 文件不能超过 20MB')
  return { kind: 'file', ext, mime: MIMES[ext], label: ext === 'pdf' ? 'PDF' : 'Word' }
}

export function libraryFileType(file) {
  if (/\.(docx?|pdf)$/i.test(file.name) || !/^(image|video)\//.test(file.type)) return documentType(file)
  const isVideo = file.type.startsWith('video/')
  if (isVideo && file.type !== 'video/mp4') throw new Error('视频请转成 mp4 格式再上传')
  const cap = isVideo ? 10 : 5
  if (!file.size) throw new Error('文件为空')
  if (file.size > cap * 1024 * 1024) throw new Error(`${isVideo ? '视频' : '图片'}不能超过 ${cap}MB`)
  return { kind: isVideo ? 'video' : 'image', mime: file.type, label: isVideo ? '视频' : '图片' }
}

export function documentLabel(filename = '') {
  return /\.pdf$/i.test(filename) ? 'PDF' : /\.docx?$/i.test(filename) ? 'Word' : '文件'
}
export function documentDownloadName(med) {
  const ext = med.filename?.match(/\.(docx?|pdf)$/i)?.[1].toLowerCase()
  return ext ? `${String(med.title || '文件').replace(/\.(docx?|pdf)$/i, '')}.${ext}` : med.title || '文件'
}
